module.exports = __webpack_public_path__ + "static/media/icon4.694d7914.svg";